// The backend sends the row title as a namespace-qualified i18n key (e.g.
// "discover:discover.trending"), so it goes straight to the translator; the
// shared localization loader only ingests "namespace:key" entries, so keys
// without a namespace would render raw. Empty keys mean the row renders
// without a header.
const resolveDiscoverRowTitle = ({ titleKey, t }) => {
    // eslint-disable-next-line custom/no-dynamic-i18n-key -- The page configuration backend supplies the row title key, so it cannot be an inline literal; translations live in the remote localization CMS.
    return titleKey.length === 0 ? "" : t(titleKey);
};
export default resolveDiscoverRowTitle;
